import React from 'react';
import PlayText, { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import { EditModeWrapper, OverlayContent, HiddenTitle } from './EditMode.styles';
import Conditional from '../../../../components/Conditional/Conditional';
import { regularWhite } from '../../../design-tokens';

type Props = {
    markedAsDeleted: boolean;
    programTitle: string;
};

const EditMode = ({ markedAsDeleted, programTitle }: Props): JSX.Element => (
    <EditModeWrapper aria-live="polite">
        <Conditional condition={markedAsDeleted}>
            <OverlayContent size={SIZE.SMALL}>{programTitle} har tagits bort ur listan.</OverlayContent>
        </Conditional>
        <Conditional condition={!markedAsDeleted}>
            <PlayText dataRt="delete-program-button" fontColor={regularWhite} underline>
                Ta bort <HiddenTitle> : {programTitle}.</HiddenTitle>
            </PlayText>
        </Conditional>
    </EditModeWrapper>
);

export default EditMode;
